import methods from '@/enums/methods';
import ThothV2 from '../base/thothV2';

class BlacklistRedeService extends ThothV2 {

  /**
   * @param {File} file
   */
  upload({ file }) {
    const data = new FormData();
    data.append('file', file);

    return this.fetch({
      url: 'blacklist',
      method: methods.POST,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data,
      maxBodyLength: Infinity,
    });
  }

  /**
   * @param {Object} params 
   */
  search(params = {}) {
    return this.fetch({
      url: 'blacklist/search',
      method: methods.GET,
      params,
    });
  }

  /**
   * @param {Object} params 
   */
  check(params = {}) {
    return this.fetch({
      url: 'blacklist/check',
      method: methods.GET,
      params,
    });
  }

  deleteLastFile() {
    return this.fetch({
      url: 'blacklist/last-import',
      method: methods.DELETE,
    });
  }

  deleteInvalidItem(params = {}) {
    return this.fetch({
      url: 'blacklist/delete-invalid',
      method: methods.DELETE,
      params,
    });
  }
}

export default new BlacklistRedeService();